/**
 * Bills: the account's outstanding statement (Customer 360, 02 §5.5) — the
 * Phase 1 statement in its own tab, with overdue by the product's rule, the
 * due-date or age view, and Open bills · Credits · Cleared. A sheet's account
 * has no bills: its statement is its balance by age.
 */
import { AccountStatement, SheetStatement } from '../../receivables/AccountStatement';
import { useActiveWorkspace } from '../../workspace/WorkspaceProvider';
import { paths } from '../../workspace/navigation';
import { useAccount } from './accountPage';

export function CustomerBills() {
    const page = useAccount();
    const { workspace } = useActiveWorkspace();
    const statementTo = paths(workspace.slug).customerStatement(page.customer.id);
    if (page.source === 'tally') {
        return (
            <AccountStatement
                state={page.statement}
                customerId={page.customer.id}
                customerName={page.customer.company}
                statementTo={statementTo}
                onChanged={text => { void page.changed(text); }}
            />
        );
    }
    const o = page.row.overdue;
    return (
        <SheetStatement
            totalType={page.customer.totalType}
            bands={[['1–45 days', o.a1], ['46–90 days', o.a2], ['91–135 days', o.a3], ['Over 135 days', o.a4]]}
            statementTo={statementTo}
        />
    );
}
